import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Toast from './Toast';
import ButtonDelete from './ui/ButtonDelete';
import '../styles/UserFavorites.css';

function UserFavorites() {
	const [favorites, setFavorites] = useState([]);
	const [toast, setToast] = useState('');
	const navigate = useNavigate();
	const { isLoggedIn } = useContext(AuthContext);

	// Pobieranie ulubionych produktów
	const fetchFavorites = async () => {
		try {
			const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/favorites`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem('authToken')}`,
				},
			});
			setFavorites(response.data.products || []);
		} catch (err) {
			console.error('Błąd pobierania ulubionych:', err);
			setFavorites([]);
		}
	};

	useEffect(() => {
		if (isLoggedIn) fetchFavorites();
	}, [isLoggedIn]);

	// Usuwanie produktu z ulubionych
	const removeFromFavorites = async (productId) => {
		if (!isLoggedIn) {
			setToast('Musisz być zalogowany, aby wykonać tą akcję.');
			navigate('/login');
			return;
		}

		try {
			await axios.delete(`${process.env.REACT_APP_API_URL}/api/favorites/remove/${productId}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem('authToken')}`,
				},
			});
			await fetchFavorites();
			setToast('Produkt usunięty z ulubionych.');
		} catch (err) {
			console.error('Błąd podczas usuwania z ulubionych:', err);
			setToast('Wystąpił błąd podczas usuwania produktu.');
		}
	};

	// Wyczyść wszystkie ulubione
	const clearFavorites = async () => {
		if (!isLoggedIn) {
			setToast('Musisz być zalogowany, aby wykonać tą akcję.');
			navigate('/login');
			return;
		}

		try {
			for (const item of favorites) {
				await axios.delete(`${process.env.REACT_APP_API_URL}/api/favorites/remove/${item._id}`, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem('authToken')}`,
					},
				});
			}
			await fetchFavorites();
			setToast('Lista ulubionych została wyczyszczona.');
		} catch (err) {
			console.error('Błąd czyszczenia ulubionych:', err);
			setToast('Wystąpił błąd podczas czyszczenia ulubionych.');
		}
	};

	if (!isLoggedIn) {
		return <p>Musisz być zalogowany, aby zobaczyć ulubione produkty.</p>;
	}

	if (favorites.length === 0) {
		return (
			<div className="favorites-container">
				<h2 style={{ margin: 20 }}>Twoje ulubione produkty</h2>
				<p>Nie masz jeszcze żadnych ulubionych produktów.</p>
			</div>
		);
	}

	return (
		<div className="favorites-container">
			<h2 style={{ margin: 20 }}>Twoje ulubione produkty</h2>

			<table className="favorites-table">
				<thead>
					<tr>
						<th>#</th>
						<th>Zdjęcie</th>
						<th>Nazwa produktu</th>
						<th>Cena</th>
						<th>Akcje</th>
					</tr>
				</thead>
				<tbody>
					{favorites.map((item, index) => (
						<tr key={item._id || index}>
							<td>{index + 1}</td>
							<td>
								{item.images?.length > 0 ? (
									<img
										src={item.images[0]}
										alt={item.name || 'Produkt'}
										className="favorites-image"
									/>
								) : (
									<div className="favorites-no-image">Brak</div>
								)}
							</td>
							<td
								className="favorites-name"
								onClick={() => item._id && navigate(`/products/${item._id}`)}
							>
								{item.name || 'Brak nazwy'}
							</td>
							<td>{item.price?.toFixed(2) || '0.00'} PLN</td>
							<td>
								<ButtonDelete
									title={`Usuń ${item.name || 'produkt'} z ulubionych`}
									aria-label={`Usuń ${item.name || 'produkt'}`}
									onClick={() => item._id && removeFromFavorites(item._id)}
								>
									Usuń
								</ButtonDelete>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			<div className="favorites-summary">
				<ButtonDelete onClick={clearFavorites}>Wyczyść ulubione</ButtonDelete>
			</div>

			{toast && <Toast message={toast} onClose={() => setToast('')} />}
		</div>
	);
}

export default UserFavorites;
